import { DotsHorizontalIcon } from '@fourthwall/icons'
import React from 'react'
import { Dropdown } from '../../Dropdown/Dropdown'
import { Icon } from '../../Icon'
import * as S from './styled'
import type { TableOptionsCellProps } from './types'

export const TableOptionsCell = ({ dropdownKey, actions, row }: TableOptionsCellProps) => {
  if (!actions) return null

  return (
    <Dropdown
      key={dropdownKey}
      content={actions.map(({ label, onClick }) => (
        <Dropdown.Item
          key={label}
          label={label}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            onClick(row)
          }}
        />
      ))}
      position="bottom-end"
    >
      <S.Container
        data-testid="TableOptionsCell"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div>
          <Icon component={DotsHorizontalIcon} height={16} />
        </div>
      </S.Container>
    </Dropdown>
  )
}
